import { HOME } from 'constant/routes'
import { Link } from 'react-router-dom'
import React, { useState } from 'react'
import PLLogo from 'img/pl-logo-purple.png'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import About from 'view/component/about'
import CookiePolicy from 'view/component/cookie-policy'
import { Menu } from 'antd'
import styles from './index.scss'

const getList = (handleOpen, handleOpenCookie) => (
  <Menu mode='horizontal'>
    <Menu.Item>
      <a onClick={handleOpen}> Terms & Conditions</a>
    </Menu.Item>
    <Menu.Item>
      {/*  <a
        href='https://www.premierleague.com/cookie-policy'
        rel='noopener noreferrer'
        target='_blank'
      >Cookies Policy</a> */}
      <a onClick={handleOpenCookie}> Cookies Policy</a>
    </Menu.Item>
  </Menu>

)

const Footer = ({ menuOpen, plcp = false }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [cookieModalVisible, setCookieModalVisible] = useState(false)
  const handleOpen = () => setIsModalVisible(true)
  const handleClose = () => setIsModalVisible(false)
  const handleOpenCookie = () => setCookieModalVisible(true)
  const handleCloseCookie = () => setCookieModalVisible(false)
  const date = new Date()
  return (
    <div className={classnames(styles.outer_wrapper, menuOpen && !plcp ? styles.open : styles.close)}>
      <div className={classnames(styles.footer_wrapper)}>
        <div>
          <p className={styles.copyright}>&#169; Premier League {date.getFullYear()}</p>
        </div>
        <div className={styles.links_wrapper}>
          {getList(handleOpen, handleOpenCookie)}
        </div>
        <div className={styles.logo_container}>
          <Link to={HOME}>
            <img
              className={styles.logo}
              src={PLLogo}
            />
          </Link>
        </div>
      </div>
      <About
        handleClose={handleClose}
        handleOpen={handleOpen}
        isModalVisible={isModalVisible}
      />
      <CookiePolicy
        handleClose={handleCloseCookie}
        handleOpen={handleOpenCookie}
        isModalVisible={cookieModalVisible}
      />
    </div>
  )
}

Footer.propTypes = {
  menuOpen: PropTypes.bool,
  plcp: PropTypes.bool
}

export default connect((state) => ({
  menuOpen: state.menu?.open
}))(Footer)
